import * as React from 'react';
import { ProgressLineWrapper, ProgressStatus, ProgressStatusText } from '../../CardLayout';
import CircleLabel from '../../CircleLabel';
import ProgressLine from '../../ProgressLine';

interface ProgressSectionProps {
	label: string;
	color: string;
	showCircle: boolean;
	currentStep: number;
	totalStep: number;
	height: string;
}

const ProgressSection = ({
	label,
	color,
	showCircle = false,
	currentStep,
	totalStep = 100,
	height = '8px'
}: ProgressSectionProps) => {
	return (
		<>
			<CircleLabel label={label} color={color} showCircle={showCircle} />
			<ProgressStatus>
				<ProgressLineWrapper>
					<ProgressLine color={color} currentStep={currentStep} totalStep={totalStep} height={height} />
				</ProgressLineWrapper>
				<ProgressStatusText>{currentStep}%</ProgressStatusText>
			</ProgressStatus>
		</>
	);
};

export default ProgressSection;
